import type { ApiRequestConfig } from "@/client/adapters/types";

type ApiDefaultsMap = Record<string, Partial<ApiRequestConfig>>;

const MODEL_API_DEFAULTS: ApiDefaultsMap = {
  "nano-banana": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 0,
  },
  "doubao-seedream-4": {
    contentType: "application/json",
    timeoutMs: 1000000,
    retries: 1,
    retryDelayMs: 1000,
  },
  "doubao-seedream-4-5-251128": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1000,
  },
  "replicate-bytedance-seedream-4": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1000,
  },
  "veo": {
    contentType: "application/json",
    timeoutMs: 300000,
    retries: 0,
  },
  "veo-special": {
    contentType: null,
    timeoutMs: 300000,
    retries: 0,
  },
  "sora-2-async": {
    contentType: null,
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1500,
  },
  "sora-2-async-remix": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1500,
  },
  "kling-video-v2-5-turbo": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1500,
  },
  "kling-lip-sync": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1500,
  },
  "doubao-seedance": {
    contentType: "application/json",
    timeoutMs: 300000,
    retries: 1,
    retryDelayMs: 1500,
  },
  "gemini-2.5-flash-image-preview": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
  },
  "gemini-2.5-flash-image": {
    endpoint: "/v1beta/models/gemini-2.5-flash-image:generateContent",
    method: "POST",
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
  },
  "gemini-3-pro-image-preview": {
    endpoint: "/v1beta/models/gemini-3-pro-image-preview:generateContent",
    method: "POST",
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
  },
  "gpt-image-1.5-all": {
    endpoint: "/v1/images/generations",
    method: "POST",
    contentType: "application/json",
    timeoutMs: 800000,
    retries: 1,
    retryDelayMs: 1000,
  },
  "grok-4-image": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1000,
  },
  "wan2.5-i2v-preview": {
    contentType: "application/json",
    timeoutMs: 600000,
    retries: 1,
    retryDelayMs: 1500,
  },
  "wan2.6-i2v": {
    contentType: "application/json",
    timeoutMs: 900000,
    retries: 1,
    retryDelayMs: 1500,
  },
};

export const getModelApiDefaults = (modelKey: string): Record<string, unknown> | undefined => {
  const defaults = MODEL_API_DEFAULTS[modelKey];
  if (!defaults) {
    return undefined;
  }
  return { ...defaults };
};
